import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "7.5",
  fill: "none",
  viewBox: "0 0 16 7.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 .75a.75.75 0 0 0-.75-.75H.75a.75.75 0 0 0 0 1.5h14.5A.75.75 0 0 0 16 .75m-6.25 6A.75.75 0 0 0 9 6H.75a.75.75 0 0 0 0 1.5H9a.75.75 0 0 0 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }